import { compose, bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { get } from 'lodash';

import ConfirmationPanel from '../../../../../donation/components/CreateConfirmationPanel';

const mapStateToProps = state => ({
  platform: get(state, 'platform.platform'),
  organization: get(state, 'organization.organization'),
  userTypeId: get(state, 'session.userTypeId'),
  user: get(state, 'session.user'),
  checkout: get(state, 'Event.checkout'),
  information: get(state, 'Event.purchaseInformation'),
  tickets: get(state, 'Event.purchaseInformation.tickets'),
  countries: get(state, 'geo.countries'),
  locale: get(state, 'session.language'),
  campaign: get(state, 'campaign.campaign')
});

const mapDispatchToProps = dispatch => bindActionCreators({

}, dispatch);

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
)(ConfirmationPanel);
